import axios from "axios";
import { config } from "../config";
import { getAccountDetails } from "../Components/Services/localStorage";
import {
  encryptData,
  decryptData
} from "./crypto";

const instance = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json"
  }
});


// ==========================================
// REQUEST INTERCEPTOR
// ==========================================

instance.interceptors.request.use(
  function (r_config) {
    // Add Authorization token
    const { accessToken } = getAccountDetails();

    if (accessToken) {
      r_config.headers.authorization = `Bearer ${accessToken}`;
    }

    // Encrypt request body
    if (
      r_config.data &&
      typeof r_config.data === "object" &&
      !(r_config.data instanceof FormData)
    ) {
      r_config.data = {
        data: encryptData(r_config.data)
      };
    } else if(r_config?.params) {
      // console.log('encrypt: ',encryptData(r_config.params))
      r_config.data = encryptData(r_config.params)
    }
    // console.log('final Request encryptData: ',r_config);
    return r_config;
  },

  function (error) {
    // console.log('interceptors req:', error);
    return Promise.reject(error);
  }
);


// ==========================================
// RESPONSE INTERCEPTOR
// ==========================================

instance.interceptors.response.use(
  function (response) {
    // console.log('response',response);
    // console.log('response URL: ',response.request.responseURL);
    // if(response.request.responseURL.includes("framework")){
    //   debugger;
    // }

    if(!response.request.responseURL.includes("/api/csa/")){
      // console.log('encrypted response-data',response.data.res);
      if (response.data?.res) {
        response.data = decryptData(
          response.data.res
        );
      }
      // console.log('decryptedData response',response);
      if(typeof response.data === 'object' && Object.keys(response.data).filter(key => Array.isArray(response.data[key])).length){
        // debugger;
        const foundArray = Object.values(response.data).find(Array.isArray);
        response.data = foundArray || [];
        // console.log('after check',response.data) 
      }

      // single object of values
      const exception_keysToCheck = ["0"];
      // && exception_keysToCheck.some(key => Object.hasOwn(response.data, key))
      if((Object.keys(response.data).length == 1 && typeof Object.values(response.data)[0] == 'object') && !exception_keysToCheck.some(key => Object.hasOwn(response.data, key))    ){
        response.data = Object.values(response.data)[0]
      }
    }

    // console.log('final response: ',response)
    return response;
  },

  function (error) {
    console.log('error:',error);
    // Handle encrypted error response
    if (error.response?.data?.res) {
      try {
        error.response.data = decryptData(
          error.response.data.res
        );
      } catch (decryptError) {
        console.error(
          "Response decryption failed",
          decryptError
        );
      }
    }

    return Promise.reject(error);
  }
);

export default instance;